import React, { useContext } from 'react'
import { BiCheckCircle } from 'react-icons/bi'
import { AiOutlineLink } from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { USER_CONTEXT } from '../context/ContextProvider'
const TaskCard = ({
  data: { id, tags, createdAt, creator, title, tagline },
}) => {
  let navigate = useNavigate()
  let { setData } = useContext(USER_CONTEXT)
  return (
    <div className="py-3 px-3.5 rounded-xl bg-[#1E1F25]">
      <div className="flex flex-col gap-y-4 w-full">
        <div className="w-full flex justify-between">
          <span className="bg-[#1EA7FF] py-1 px-3 font-medium text-sm text-white w-fit rounded-md">
            {tags?.split(' ')[0] && tags?.split(' ')[0]}
          </span>
          <div className="flex gap-x-2">
            {id && (
              <RiDeleteBin6Line
                onClick={() => {
                  setData({
                    type: 'DELETE_TASK',
                    payload: { id },
                  })
                }}
                className="w-4 h-auto text-gray-400 hover:text-red-800 cursor-pointer"
              />
            )}
            <AiOutlineLink
              className="w-4 h-auto text-gray-400 hover:text-gray-500 cursor-pointer"
              onClick={() => navigate(id && '/tasks/' + id)}
            />
          </div>
        </div>
        <div>
          <h3 className="text-[#F6F6F6] text-base font-medium">{title}</h3>
          <p className="text-[#768396] text-sm">{tagline}</p>
        </div>
        <span className="py-1 px-3 border border-[#2C2D37] rounded-lg text-white w-fit">
          {createdAt}
        </span>
        <div className="w-full flex justify-between items-center">
          <div className="flex items-center gap-x-2 text-[#768396] text-sm font-medium">
            <div className="h-7 w-7 rounded-full bg-gray-600">
              {creator.avatar && (
                <img
                  className="w-full h-auto rounded-full"
                  src={creator.avatar}
                />
              )}
            </div>
            <p>{creator.name}</p>
          </div>
          <div className="flex gap-x-2 items-center text-[#768396]">
            <BiCheckCircle />
            <p className="text-sm">0/8</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TaskCard
